import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import { ButtonLink } from "@/components/Buttons/index";
import { ProfilePasscodeForm } from "@/components/Form/index";
import ProfileIconImage from "@/components/Images/ProfileIconImage";
import Loading from "@/components/Loading";
import { useAccountSendProfilePinResetTokenMutation, useAuthSelectProfileMutation, useAuthUserQuery, useNotification, usePreviousPath, useRequireLogin } from "@/hooks";
import { PROFILE_MAX } from "@/lib/constants";
import routes from "@/lib/routes";
import styles from "@/styles/Profile.module.scss";
import { useRouter } from "next/router";
import { useCallback, useEffect, useReducer } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const initializeValue = {
  selectedProfile: null,
  passcodeInput: false,
  editProfileSelect: false
};
const reducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return initializeValue;
    case "edit":
      return _objectSpread(_objectSpread({}, state), {}, {
        editProfileSelect: action.value
      });
    case "set":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedProfile: action.profile,
        passcodeInput: action.profile.needPasscode
      });
  }
};
export default function SelectProfile(_ref) {
  var _user$currentProfile;
  let {
    type,
    backToPrevPath = false
  } = _ref;
  useRequireLogin();
  const {
    showNotification
  } = useNotification();
  const prevPath = usePreviousPath();
  const router = useRouter();
  const {
    0: state,
    1: dispatch
  } = useReducer(reducer, initializeValue);
  const {
    data: {
      user
    }
  } = useAuthUserQuery();
  const [select, {
    data: selectProfileData,
    loading,
    error
  }] = useAuthSelectProfileMutation({
    onCompleted: () => {
      if (type === "switch") {
        if (backToPrevPath) {
          window.location.href = prevPath || routes.home;
        } else {
          window.location.href = routes.home;
        }
      }
    },
    // update: (cache) => {
    //   cache.evict({ fieldName: "userFavorites" });
    //   cache.evict({ fieldName: "feavoritesByConentType" });
    //   cache.evict({ fieldName: "getViewingHistory" });
    //   cache.gc();
    // },
    onError: e => console.log(e) // Uncaught Errorになるのでここでハンドリングする
  });

  useEffect(() => {
    if (type !== "switch" && user && user.profiles.length === 1) {
      const profile = user.profiles[0];
      if (profile.needPasscode) {
        dispatch({
          type: "set",
          profile
        });
      } else {
        select({
          variables: {
            profileId: profile.id
          }
        });
      }
    }
  }, [type, user]);
  const handleClick = useCallback(profile => {
    return () => {
      if (state.editProfileSelect) {
        router.push(routes.profileEdit(profile.id));
      } else if (profile.needPasscode) {
        dispatch({
          type: "set",
          profile
        });
      } else {
        select({
          variables: {
            profileId: profile.id
          }
        });
      }
    };
  }, [state.editProfileSelect]);
  const handleEdit = useCallback(() => {
    if (state.editProfileSelect) {
      dispatch({
        type: "edit",
        value: false
      });
    } else {
      dispatch({
        type: "edit",
        value: true
      });
    }
  }, [state.editProfileSelect]);
  const [sendProfilePinResetToken] = useAccountSendProfilePinResetTokenMutation({
    onCompleted: _ref2 => {
      let {
        sendProfilePinResetToken
      } = _ref2;
      if (sendProfilePinResetToken !== null && sendProfilePinResetToken !== void 0 && sendProfilePinResetToken.result) {
        showNotification("暗証番号リセットメールをお送りしました", {
          time: 2000
        });
      }
    }
  });
  const resetPin = useCallback(() => {
    sendProfilePinResetToken();
  }, []);
  const handleBack = useCallback(() => dispatch({
    type: "reset"
  }), []);
  const onSubmit = useCallback(data => {
    select({
      variables: {
        profileId: Number(data.id),
        passcode: data.passcode,
        type: "auth"
      }
    });
  }, []);
  const isOwner = user === null || user === void 0 || (_user$currentProfile = user.currentProfile) === null || _user$currentProfile === void 0 ? void 0 : _user$currentProfile.ownerProfile;
  if (selectProfileData) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.select,
    children: [loading && /*#__PURE__*/_jsx(Loading, {
      fixed: true
    }), !loading && state.passcodeInput && /*#__PURE__*/_jsx(ProfilePasscodeForm, {
      profile: state.selectedProfile,
      back: handleBack,
      onSubmit: onSubmit,
      error: error,
      resetPin: resetPin,
      type: "auth"
    }), !loading && !state.selectedProfile && !state.passcodeInput && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("h2", {
        children: [!state.editProfileSelect && "ご利用されるプロフィールを選択", state.editProfileSelect && "編集するプロフィールを選択してください。"]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.profiles,
        children: user && user.profiles.map(profile => /*#__PURE__*/_jsx("div", {
          className: styles.profileItem,
          children: /*#__PURE__*/_jsx(ProfileIconImage, _objectSpread(_objectSpread({}, profile), {}, {
            onClick: handleClick(profile)
          }))
        }, `profile-icon-${profile.id}`))
      }), type == "switch" && isOwner && /*#__PURE__*/_jsxs("div", {
        className: styles.btns,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.btn,
          children: /*#__PURE__*/_jsx(ButtonLink, {
            href: routes.profileAdd,
            borderGray: true,
            medium: true,
            disabled: user && user.profiles.length >= PROFILE_MAX,
            children: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u306E\u8FFD\u52A0"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.btn,
          children: /*#__PURE__*/_jsxs(ButtonMultiClick, {
            borderGray: true,
            medium: true,
            onClick: handleEdit,
            children: [state.editProfileSelect && "キャンセル", !state.editProfileSelect && "プロフィールの編集"]
          })
        })]
      })]
    })]
  });
}